<template>
    <div>
        <h3 class="m-0 shadow-text-none">{{ $t('setting_show_result_as') }}</h3>
        <div class="chart-box flex items-center mt-4">
            <XCheckbox
                :checked="chartType == 'bar'"
                @input="handleSelectChartType($event)"
                :name="`chart-select-${questionIndex}`"
                value="bar"
                size="lg"
                theme="dark"
            >
                <i class="fas fa-chart-bar shadow-text-none" style="transform: rotate(90deg)"></i>
                <span class="font-size-16 shadow-text-none"> {{ $t('setting_bar_chart') }} </span>
            </XCheckbox>
            <XCheckbox
                :checked="chartType == 'pie'"
                @input="handleSelectChartType($event)"
                :name="`chart-select-${questionIndex}`"
                value="pie"
                size="lg"
                theme="dark"
            >
                <i class="fas fa-chart-pie shadow-text-none"></i>
                <span class="font-size-16 shadow-text-none"> {{ $t('setting_pie_chart') }} </span>
            </XCheckbox>
        </div>
    </div>
</template>

<script>
import XCheckbox from '@/components/v2/XCheckbox'

export default {
    components: {
        XCheckbox
    },

    props: {
        chartType: {
            type: String,
            required: true
        },

        questionIndex: {
            type: Number,
            required: true
        }
    },

    methods: {
        handleSelectChartType(event) {
            this.$emit('input', event.target.value)
        }
    }
}
</script>

<style>
.chart-box {
    column-gap: 1rem;
}
</style>